var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSettings24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_settings24x24",
    transform: "translate(-3.001 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(3.001 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M15.948,7.109a.521.521,0,0,0-.515-.394,1.766,1.766,0,0,1-1.209-3.072.444.444,0,0,0,.049-.6,7.918,7.918,0,0,0-1.267-1.28.444.444,0,0,0-.608.049,1.843,1.843,0,0,1-2,.444A1.777,1.777,0,0,1,9.323.52.444.444,0,0,0,8.931.052a7.983,7.983,0,0,0-1.8,0,.444.444,0,0,0-.4.458A1.777,1.777,0,0,1,5.64,2.212a1.849,1.849,0,0,1-1.98-.451.444.444,0,0,0-.6-.051A7.951,7.951,0,0,0,1.762,2.99.444.444,0,0,0,1.81,3.6a1.772,1.772,0,0,1,.444,2A1.848,1.848,0,0,1,.517,6.674a.435.435,0,0,0-.462.393,8.017,8.017,0,0,0,0,1.82.533.533,0,0,0,.524.394,1.754,1.754,0,0,1,1.646,1.095,1.777,1.777,0,0,1-.444,1.977.444.444,0,0,0-.049.6,7.945,7.945,0,0,0,1.265,1.281.444.444,0,0,0,.609-.048A1.841,1.841,0,0,1,5.6,13.743,1.777,1.777,0,0,1,6.68,15.478a.444.444,0,0,0,.393.467,7.964,7.964,0,0,0,1.8.005.444.444,0,0,0,.4-.458,1.777,1.777,0,0,1,1.095-1.705,1.846,1.846,0,0,1,1.981.451.444.444,0,0,0,.6.051,7.962,7.962,0,0,0,1.294-1.28.444.444,0,0,0-.048-.608,1.772,1.772,0,0,1-.444-1.995,1.791,1.791,0,0,1,1.636-1.084h.1a.444.444,0,0,0,.468-.392,7.981,7.981,0,0,0,0-1.822ZM8,12.608a4.61,4.61,0,1,1,3.959-2.246L9.939,8.342A2.829,2.829,0,0,0,6.591,4.511a.32.32,0,0,0-.221.223.313.313,0,0,0,.089.306s1,1,1.333,1.338a.207.207,0,0,1,.03.148v.022a6.374,6.374,0,0,1-.152.977l-.027.018-.022.023a6.285,6.285,0,0,1-.991.154H6.6a.213.213,0,0,1-.154-.065l-1.3-1.3a.325.325,0,0,0-.233-.1.316.316,0,0,0-.3.241A2.829,2.829,0,0,0,8.443,9.842l2.044,2.044A4.588,4.588,0,0,1,8,12.608Z",
    transform: "translate(-.002 .001)",
    fill: "#999"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSettings24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_settings24x24.c52974e39e7e789f1b0130e90dfbc716.svg";